import { render } from "./TcpaDisclaimer.vue?vue&type=template&id=16cb2250"
import script from "./TcpaDisclaimer.vue?vue&type=script&lang=js"
export * from "./TcpaDisclaimer.vue?vue&type=script&lang=js"

import "./TcpaDisclaimer.vue?vue&type=style&index=0&id=16cb2250&lang=css"

import exportComponent from "../../../vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/components/leadforms/TcpaDisclaimer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16cb2250"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16cb2250', __exports__)) {
    api.reload('16cb2250', __exports__)
  }
  
  module.hot.accept("./TcpaDisclaimer.vue?vue&type=template&id=16cb2250", () => {
    api.rerender('16cb2250', render)
  })

}


export default __exports__